import React from "react";
import { FiShoppingCart } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

import { useCart } from "../cart";
import { buildAccent, buildFallbackLabel, formatPrice } from "../utils";
import { storeProductPath } from "../../routes";


export default function ProductCard({ product, index = 0 }) {
  const accent = buildAccent(index);
  const { addItem } = useCart();
  const navigate = useNavigate();
  const productName = String(product?.name || product?.slug || "Nomsiz kitob").trim();
  const productPath = storeProductPath(product.slug);

  const handleOpenDetails = () => {
    navigate(productPath);
  };

  const handleCardKeyDown = (event) => {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleOpenDetails();
    }
  };

  const handleAddToCart = (event) => {
    event.stopPropagation();
    addItem(product, 1);
  };

  return (
    <article
      aria-label={`${productName} mahsulotini ko'rish`}
      className={`store-card store-card-${accent} store-card-clickable`}
      onClick={handleOpenDetails}
      onKeyDown={handleCardKeyDown}
      role="link"
      tabIndex={0}
      title={productName}
    >
      <div
        aria-label={`${productName} mahsulotini ko'rish`}
        className="store-card-media"
        title={productName}
      >
        {product.primary_image ? (
          <img alt={productName} loading="lazy" src={product.primary_image} />
        ) : (
          <div className="store-card-fallback">{buildFallbackLabel(productName)}</div>
        )}
      </div>

      <div className="store-card-body">
        <div className="store-card-head">
          <h3 title={productName}>{productName}</h3>
        </div>
        <div className="store-card-foot">
          <div className="store-price-block">
            <div className="store-price-inline">
              <strong>{formatPrice(product.price)}</strong>
            </div>
            {product.compare_at_price ? <span className="store-price-compare">{formatPrice(product.compare_at_price)}</span> : null}
          </div>

          <div className="store-card-actions store-card-actions-single">
            <button
              aria-label="Savatga qo'shish"
              className="store-add-button"
              onClick={handleAddToCart}
              title="Savatga qo'shish"
              type="button"
            >
              <FiShoppingCart aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </article>
  );
}
